// extracted by mini-css-extract-plugin
export var excerpts = "excerpt-module--excerpts--mo09x";
export var excerpt = "excerpt-module--excerpt--mMoIn";
export var title = "excerpt-module--title--k3rfq";